module.exports = __webpack_public_path__ + "media/images/firsttime_contents01_sp-18cc1bff3e63764d14bf790e6e326225.png";